import {
  Button,
  Card,
  Box,
  CardContent,
  Chip,
} from "@mui/material";
import {
  HiOutlinePencilSquare,
  HiOutlineUserCircle,
} from "react-icons/hi2";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { User } from "../../../../app/slices/userSlice";
import { PointOfSales } from "../../../../app/slices/posSlice";
import Permission from "../../../../components/userPermission/userPermission";
import ConfirmationDialog from "../../../../helpers/ConfirmationDialog";
import { BRAND } from "../../../../components/MobileList";
import { InfoCardHeader, InfoField, infoContentSx } from "../../../../components/InfoCard";

const getUserType = (_user) => {
  if (_user.is_representative) return "مندوب";
  else if (_user.is_j_rep) return "مندوب جملة";
  else if (_user.role === "pos")
    return `نقطة بيع : ${_user.pos_number ? `(${_user.pos_number})` : ""}`;
  else return "غير معرف";
};

// Shared between the "المعاملات المالية" and "مناقلات الدفع الالكتروني" tabs so
// both show the same user summary/actions.
const UserInfoCard = () => {
  const dispatch = useDispatch();
  const { user_id } = useParams();
  const user = useSelector((state) => state.user.user.form);

  const [openActive, setOpenActive] = useState(false);

  const handleConfirmActive = () => {
    setOpenActive(false);
    dispatch(
      User.WalletActivation({
        user_id: user.id,
        is_active: !user.wallet?.is_active,
      }),
    )
      .then(() => dispatch(User.getByIdData(user_id)))
      .catch(() => dispatch(User.getByIdData(user_id)));
  };

  return (
    <Card sx={{ height: "100%" }}>
      <ConfirmationDialog
        open={openActive}
        title="تاكيد"
        message={
          user.wallet?.is_active
            ? "هل انت متاكد من الغاء تفعيل المحفظة: "
            : "هل انت متاكد من تفعيل المحفظة :"
        }
        name={user.name}
        confirmText="تاكيد"
        cancelText="الغاء"
        onConfirm={() => handleConfirmActive()}
        onCancel={() => setOpenActive(false)}
      />
      <InfoCardHeader
        icon={<HiOutlineUserCircle />}
        tone={BRAND}
        title="معلومات المستخدم"
        action={
          <Permission permission="pos_edit">
            <Button
              size="small"
              variant="outlined"
              startIcon={<HiOutlinePencilSquare />}
              onClick={() => dispatch(PointOfSales.getById(user.pos_id))}
              sx={{ py: 0.25 }}
            >
              تعديل
            </Button>
          </Permission>
        }
      />
      <CardContent sx={infoContentSx}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: 2,
            rowGap: 1,
          }}
        >
          <InfoField label="الاسم">{user?.name}</InfoField>
          <InfoField label="رقم الهاتف">{user?.mobile}</InfoField>
          <InfoField label="نوع الحساب">{user ? getUserType(user) : ""}</InfoField>
          <InfoField label="حالة المحفظة">
            <Chip
              label={user.wallet?.is_active ? "فعال" : "غير فعال"}
              color={user.wallet?.is_active ? "success" : "error"}
              size="small"
              onClick={() => setOpenActive(true)}
              sx={{ height: 20, fontSize: 11 }}
            />
          </InfoField>
        </Box>
      </CardContent>
    </Card>
  );
};

export default UserInfoCard;
